import { useResourceContext } from 'react-admin';
import { useSubscribe } from '../controller/useSubscribe';
/**
 * Hook to subscribe to the events for a record list
 * on mount (and unsubscribe on unmount).
 *
 * @param {SubscriptionCallback<RecordEvent>} subscriptionCallback the callback to be executed when an event is published concerning the resource
 * @param {string} resource optional if used inside a ResourceContextProvider
 * @param {UseSubscribeOptions} options Options object
 *
 * @example // Auto-Updated PostList
 *
 * ```tsx
 * const PostList = () => {
 *     const notify = useNotify();
 *     const refresh = useRefresh();
 *     useSubscribeToRecordList(() => {
 *         refresh();
 *         notify('list updated server-side');
 *     });
 *     return (
 *         <List>
 *             <Datagrid>
 *                 <TextField source="title" />
 *             </Datagrid>
 *         </List>
 *     );
 * };
 * ```
 *
 * @example // Providing resource manually
 *
 * ```tsx
 * const PostList = () => {
 *     const notify = useNotify();
 *     const refresh = useRefresh();
 *     useSubscribeToRecordList(() => {
 *         refresh();
 *         notify('list updated server-side');
 *     }, 'posts');
 *     return (
 *         <List>
 *             <Datagrid>
 *                 <TextField source="title" />
 *             </Datagrid>
 *         </List>
 *     );
 * };
 * ```
 */
export var useSubscribeToRecordList = function (subscriptionCallback, resource, options) {
    var actualResource = useResourceContext({ resource: resource });
    var topic = actualResource ? "resource/".concat(actualResource) : null;
    // if no resource, the topic will be empty and the subscription will be a no-op
    useSubscribe(topic, subscriptionCallback, options);
};
